import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class PrivacyPolicy extends Component {

    componentDidMount() {
        document.body.classList.add('privacy-policy-page'); // Add the class when the component mounts
        window.scrollTo(0, 0); // Scroll to the top of the page
    }

    componentWillUnmount() {
        document.body.classList.remove('privacy-policy-page'); // Remove the class when the component unmounts
    }

    render() {
        const { t } = this.props;
        return (
        <div className="bg-gradient-to-r from-blue-100 via-white to-blue-100 min-h-screen py-16 privacy-policy-page">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-bold text-center text-blue-700 mb-8">
                {t('privacyPolicyPage.title')}
            </h1>
            <p className="text-gray-700 mb-5">{t('privacy_last_updated_on')}</p>
            <div className="prose lg:prose-lg max-w-none bg-white p-6 rounded-lg shadow-md">
                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.introduction.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.introduction.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.informationWeCollect.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.informationWeCollect.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.howWeUse.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.howWeUse.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.sharing.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.sharing.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.security.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.security.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.yourRights.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.yourRights.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.dataRetention.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.dataRetention.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.dataDeletion.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.dataDeletion.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.healthData.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.healthData.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.changes.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.changes.content')}</p>

                <p className="text-gray-800 font-semibold">{t('privacyPolicyPage.contact.title')}</p>
                <p className="text-gray-700">{t('privacyPolicyPage.contact.content')}</p>
            </div>
            </div>
        </div>
        );
    }
}

export default withTranslation()(PrivacyPolicy);